import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs/Subject';
import { EmailService } from '../../core/email.service';
import {AngularFireAuth} from 'angularfire2/auth';


@Component({
    selector: 'rsvp',
    template: `
        <div class="rsvp_content">
            <div class="spinner" *ngIf="loading; else loaded"><mat-spinner></mat-spinner></div>
        </div>
        <ng-template #loaded>
            <div *ngIf="valid; else notValid">
                <div class="heading">Thanks!</div>
                <p>We’ve received your RSVP for {{event_title}}.</p>
                <p>{{greeting}}</p>
                <p class="small">If you need to change your RSVP, just click the button in the invitation.</p>
            </div>
        </ng-template>
        <ng-template #notValid>
            <div class="error">Invalid RSVP</div>
        </ng-template>
    `,
    styles: [`
        :host { display:block;}
        .rsvp_content {font-family: "Ubuntu",sans-serif; font-size: 24px; font-weight: 100; text-align: center; padding-top: 100px; }
        .rsvp_content .spinner { display: flex; justify-content: center; }
        .rsvp_content .heading {font-family: "ff-netto-web",sans-serif; font-size: 60px; }
        .rsvp_content p {  }
        .rsvp_content p.small { font-size: 14px; font-weight: normal; }
    `]
})
export class RsvpComponent {
    private $destroy: Subject<boolean> = new Subject();
    loading = true;
    valid = false;
    greeting = '';
    event_title = '';
    constructor(private afAuth: AngularFireAuth, private route: ActivatedRoute, private email: EmailService) {
        route.params.takeUntil(this.$destroy).subscribe(params => {
            if (params.hasOwnProperty('rsvpId')) {
                const response = this.email.updateRsvp(params.rsvpId);
                response.subscribe(data => {
                    this.loading = false;
                    this.event_title = data.title;
                    if (data.message == '1') {
                        this.valid = true;
                        this.greeting = 'See you there!';
                    } else  if (data.message == '0') {
                        this.valid = true;
                        this.greeting = 'Sorry you can\'t make it!';
                    }
                });
            } else {
                this.loading = false;
                this.valid = false
            }
        });

    }
    ngOnDestroy(){
        this.$destroy.next();
        this.$destroy.complete();
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/rsvp/rsvp.component.ts